import { Button } from "antd";
import Phone from "../phone/phone.component";
import './alternative-phones.styles.css';

const maxAlternativePhones = 3;

const AlternativePhones = ({ alternativePhones, setAlternativePhones }) => {

    const handleDeleteAlternativePhone = id => {
        const arr = [...alternativePhones]
        const newState = arr.filter(elem => elem.id !== id)
        setAlternativePhones(newState)
    }

    const handleAddAlternativePhone = () => {
        setAlternativePhones(
            [...alternativePhones,
            {
                id: new Date().valueOf(),
                render: (id, callback) =>
                    <Phone
                        id={id}
                        onDelete={callback}
                        key={id}
                    />
            }
            ])
    };

    return (
        <>
            {alternativePhones.map((elem) => elem.render(elem.id, handleDeleteAlternativePhone))}

            {alternativePhones.length < maxAlternativePhones &&
                <Button
                    className="alternative-phone-add-button "
                    onClick={handleAddAlternativePhone}
                    type="default"
                >
                    Agregar Teléfono
                </Button>
            }
        </>
    );
}

export default AlternativePhones;